$(function () {
    // Masks
    var maskBehavior = function (val) {
            return val.replace(/\D/g, '').length === 11
                ? '(00) 00000-0000'
                : '(00) 0000-00009'
        },
        options = {
            onKeyPress: function (val, e, field, options) {
                field.mask(maskBehavior.apply({}, arguments), options)
            },
        }
    $('.form-tel').mask(maskBehavior, options)
    $('.form-cep').mask('00000-000')
    $('.form-cpf').mask('000.000.000-00')
    $('.form-cnpj').mask('00.000.000/0000-00')

    // Floating Labels in CF7
    // var formControls = document.querySelectorAll(
    //     '.wpcf7 .form-control, .wpcf7 .form-select'
    // )

    // for (var i = 0; i < formControls.length; i++) {
    //     var input = formControls[i]
    //     var label = input.parentNode.parentNode.querySelector('label')

    //     input.addEventListener('focus', function () {
    //         this.parentNode.parentNode.classList.add('active')
    //     })

    //     input.addEventListener('blur', function () {
    //         var cval = this.value
    //         if (cval.length < 1) {
    //             this.parentNode.parentNode.classList.remove('active')
    //         }
    //     })

    //     if (label) {
    //         label.addEventListener('click', function () {
    //             var input = this.parentNode.querySelector(
    //                 '.form-control, .form-select'
    //             )
    //             input.focus()
    //         })
    //     }
    // }

    // Get container offset
    offsetWidth()
    $(window).on('resize', function () {
        offsetWidth()
    })

    function offsetWidth() {
        var containerOffset = $('.container').offset().left
        $('.container-offset').css('width', containerOffset)
    }

    // Smooth Scrolling to Anchor Links
    $('.smooth-scroll').bind('click', function (event) {
        var $anchor = $(this)

        $('html, body')
            .stop()
            .animate(
                {
                    scrollTop: $($anchor.attr('href')).offset().top - 300,
                },
                1000
            )

        event.preventDefault()
    })

    // Fancybox
    Fancybox.bind()

    // Aos
    // AOS.init()

    function registra_IncContatos(form) {
        nome = jQuery(form).find('[name="nome"]').val()
        email = jQuery(form).find('[name="email"]').val()
        telefone = jQuery(form).find('[name="telefone"]').val()

        var empreendimento_id = '82'

        var url = window.location.href
        var token_empresa = '695af152-64d1-11eb-bb42-73319a7063a1'
        var origem = 'SI'
        var utm_source = jQuery('#utm_source').val()
        var utm_medium = 'website'

        if (jQuery('#utm_medium').val() != '') {
            utm_medium = jQuery('#utm_medium').val()
        }

        var utm_campaign = jQuery('#utm_campaign').val()

        incContato(
            nome,
            email,
            telefone,
            '',
            '',
            empreendimento_id,
            url,
            origem,
            utm_source,
            utm_medium,
            utm_campaign,
            token_empresa
        )
        console.log('Inc. Contato Enviado')
    }

    document.addEventListener(
        'wpcf7mailsent',
        function (event) {
            if (event.detail.contactFormId == '5') {
                var form = '#' + event.detail.unitTag
                registra_IncContatos(form)

                inc_event('conversao', 'form', 'form banner')

                // setTimeout(function () {
                //     window.location.href =
                //         'https://bellavista.vicengenharia.com.br/sucesso/'
                // }, 1000)
            }
        },
        false
    )

    console.log('Inc. GTM-GA Inicializado')

    function inc_event(category, action, label) {
        var obj = {
            'inc-category': category,
            'inc-action': action,
            'inc-label': label,
        }

        dataLayer.push(obj)
        dataLayer.push({
            event: 'inc-event',
        })
        console.log('Inc. GTM-GA Event:')
        console.log(obj)
    }

    jQuery('.inc-track').on('click', function (e) {
        inc_event(
            jQuery(this).data('category'),
            jQuery(this).data('action'),
            jQuery(this).data('label')
        )
    })

    console.log('INC. Saudação WPP')

    function alteraSaudacaoWPP(saudacao) {
        jQuery('.wpp_saudacao:not(.wpp_saudacao_active)').each(function (
            index
        ) {
            jQuery(this).addClass('wpp_saudacao_active')

            var wpp = jQuery(this)
                .attr('href')
                .replace(/[^0-9]/gi, '')
            var wpp_link =
                'https://wa.me/+' +
                wpp +
                '/?text=' +
                encodeURIComponent(saudacao)
            jQuery(this).attr('href', wpp_link)
        })
    }

    var utm_source = jQuery('#utm_source').val()
    var utm_medium = jQuery('#utm_medium').val()
    var utm_campaign = jQuery('#utm_campaign').val()
    var utm_term = jQuery('#utm_term').val()
    var utm_content = jQuery('#utm_content').val()
    var url_origem = jQuery('#url_origem').val()
    var data_cache = new Date()
    data_cache =
        data_cache.getFullYear() +
        '-' +
        (data_cache.getMonth() + 1) +
        '-' +
        data_cache.getDate()

    var cache_utms =
        utm_source +
        '_' +
        utm_medium +
        '_' +
        utm_campaign +
        '_' +
        utm_term +
        '_' +
        utm_content +
        '_' +
        url_origem +
        '_' +
        data_cache

    if (
        (localStorage.hasOwnProperty('cache_utms') &&
            cache_utms != localStorage.getItem('cache_utms')) ||
        !localStorage.hasOwnProperty('cache_utms')
    ) {
        var data = JSON.stringify({
            action: 'consultar_utms',
            utm_source: utm_source,
            utm_medium: utm_medium,
            utm_campaign: utm_campaign,
            utm_term: utm_term,
            utm_content: utm_content,
            url_origem: url_origem,
        })

        var xhr = new XMLHttpRequest()
        xhr.open('POST', 'https://automacao.vicengenharia.com.br/saudacao')
        xhr.send(data)
        xhr.onload = function () {
            var response = JSON.parse(xhr.responseText)

            if (xhr.status === 200 && response.stt == true) {
                var msg_saudacao = response.saudacao.saudacao

                localStorage.setItem('saudacaoWPP', msg_saudacao)
                alteraSaudacaoWPP(msg_saudacao)
            }
        }
    } else {
        if (
            localStorage.getItem('saudacaoWPP') != '' &&
            localStorage.getItem('saudacaoWPP') != null
        ) {
            alteraSaudacaoWPP(localStorage.getItem('saudacaoWPP'))
        }
    }

    setTimeout(function () {
        localStorage.setItem('cache_utms', cache_utms)
    }, 1000)
})
